import React, { useState } from 'react';
import Box from 'common/oldJavascripts/components/Base/Box';
import LayoutContent from 'common/oldJavascripts/components/Base/Layout/LayoutContent';
import Header from 'common/oldJavascripts/components/Base/Header';
import DocumentManagement from 'admin/components/DocumentManagement';
import DocumentMetaDataWrapper from './DocumentMetaDataWrapper';
import ReplacementWrapper from './DocumentReplacementWrapper';
import DocumentViewWrapper from './DocumentViewWrapper';
import UploaderWrapper from './DocumentUploaderWrapper';
import BoxItem from 'common/oldJavascripts/components/Base/Box/BoxItem';
import Loader from 'common/components/Loader';
import TemplateClone from 'admin/components/TemplateClone';
import withApi from 'common/hoc/withApi';
import listParams from 'admin/components/DocumentManagement/listParams';
import ajax from 'common/utilities/ajax.js';
import history from 'common/constants/config/history';
import withSnackbarNotification from 'common/hoc/withSnackbarNotification';
import * as SnackbarVariants from 'common/constants/componentData/snackbarVariants';
import useFeatureFlags from 'common/hooks/useFeatureFlags';
import { compose } from 'redux';
import Notification from 'studio/components/OfferPage/OfferDrafts/Notification';

const SUCCESS_MESSAGE = 'Template cloned successfully.';
const ERROR_MESSAGE =
  'There was an error while trying to clone the template/Duplicate Name.';

// Here we can hack and cleanup, rename, etc the info coming down from BE
const transformTemplate = template => {
  const {
    expireOn,
    uploadedBy: { extra: uploadedBy = {} } = {},
    updatedBy: { extra: updatedBy = {} } = {},
  } = template;
  const { fullName: uploadedByName = null } = uploadedBy || {};
  const { fullName: updatedByName = null } = updatedBy || {};
  return {
    ...template,
    expireOn,
    uploadedBy: uploadedByName || '- Unknown Start+ Admin -',
    updatedBy: updatedByName || '- Unknown Start+ Admin -',
  };
};

const DocumentLibrary = props => {
  const {
    templates: { reload, status, data: { items = [], totalItems } = {} },
    pushSnackbarNotification,
  } = props;
  const isLoading = status === 'loading';

  const [templateIdBeingEdited, setTemplateIdBeingEdited] = useState();
  const [templateIdBeingViewed, setTemplateIdBeingViewed] = useState();
  const [templateIdBeingReplaced, setTemplateIdBeingReplaced] = useState();
  const flags = useFeatureFlags();
  const globalNavFlag = flags.includes('GlobalNavbar');
  const [templateIdBeingCloned, setTemplateIdBeingCloned] = useState();
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const templateBeingEdited =
    templateIdBeingEdited &&
    items.find(({ id }) => id === templateIdBeingEdited);

  const templateBeingCloned =
    templateIdBeingCloned &&
    items.find(({ id }) => id === templateIdBeingCloned);
  const templateBeingReplaced =
    templateIdBeingReplaced &&
    items.find(({ id }) => id === templateIdBeingReplaced);
  const updateTemplate = (id, patch) => {
    const url = `/workflow/templates/${id}/edit`;
    return ajax
      .put(url, { payload: patch }, { json: true })
      .then(() => reload());
  };

  const handleReload = value => {
    if (value) {
      setIsSnackbarOpen(true);
      setSeverity('success');
      setMessage(SUCCESS_MESSAGE);
      reload();
    }
  };
  const handleError = err => {
    if (err) {
      setIsSnackbarOpen(true);
      setSeverity('error');
      setMessage(err || ERROR_MESSAGE);
    }
  };

  const toggleTemplateVisibility = templateId => {
    const template = items.find(({ id }) => id === templateId);
    updateTemplate(templateId, { visible: !template.visible });
  };

  const handldeDownloadTemplate = id => {
    ajax
      .get(`/workflow/templates/${id}/download`)
      .then(response => {
        const { url } = response;
        window.location.href = url;
        pushSnackbarNotification({
          message: 'File downloaded successfully.',
          variant: SnackbarVariants.SUCCESS,
        });
      })
      .catch(() => {
        pushSnackbarNotification({
          message: 'There was an error while trying to download the file',
          variant: SnackbarVariants.ERROR,
        });
      });
  };

  return (
    <React.Fragment>
      <LayoutContent globalNavFlag={globalNavFlag}>
        <Box>
          <BoxItem>
            <Header>
              <Header.Title>
                <span data-test-id="DocumentLibrary-title">
                  Global Document Library
                </span>
              </Header.Title>
              <Header.Nav>
                <UploaderWrapper updater={() => reload()} />
              </Header.Nav>
            </Header>
          </BoxItem>
          <BoxItem>
            {isLoading ? (
              <Loader />
            ) : (
              <DocumentManagement
                data={items.map(transformTemplate)}
                length={totalItems || 0}
                handleActiveFlag={toggleTemplateVisibility}
                handleEdit={setTemplateIdBeingEdited}
                handleReplace={setTemplateIdBeingReplaced}
                handleOpenDocViewer={setTemplateIdBeingViewed}
                handleDownloadDocument={id => handldeDownloadTemplate(id)}
                handleClone={id => setTemplateIdBeingCloned(id)}
              />
            )}
          </BoxItem>
        </Box>
      </LayoutContent>
      <DocumentMetaDataWrapper
        isOpen={!!templateIdBeingEdited}
        name={templateBeingEdited ? templateBeingEdited.name : ''}
        expireOn={templateBeingEdited && templateBeingEdited.expireOn}
        id={templateBeingEdited && templateBeingEdited.id}
        tags={templateBeingEdited ? templateBeingEdited.categories : []}
        handleCancel={() => setTemplateIdBeingEdited(null)}
        handleSubmit={() => {
          setTemplateIdBeingEdited(null);
          reload();
        }}
      />
      {!!templateIdBeingViewed && (
        <DocumentViewWrapper
          onClose={() => setTemplateIdBeingViewed(null)}
          params={{ templateId: templateIdBeingViewed }}
        />
      )}
      {!!templateIdBeingReplaced && (
        <ReplacementWrapper
          open={!!templateIdBeingReplaced}
          oldDocument={templateBeingReplaced}
          closeHandler={() => {
            setTemplateIdBeingReplaced(null);
            reload();
          }}
          mappingHandler={() =>
            history.push({
              pathname: `/library/documents/${templateIdBeingReplaced}/replacement`,
            })
          }
        />
      )}
      {templateIdBeingCloned && (
        <TemplateClone
          id={templateIdBeingCloned}
          tags={templateBeingCloned ? templateBeingCloned.categories : []}
          name={templateBeingCloned ? templateBeingCloned.name : ''}
          expireOn={templateBeingCloned && templateBeingCloned.expireOn}
          handleCancel={() => setTemplateIdBeingCloned(null)}
          handleReload={value => handleReload(value)}
          handleError={err => handleError(err)}
        />
      )}
      <Notification
        message={message}
        open={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        onClose={() => setIsSnackbarOpen(false)}
        severity={severity}
      />
    </React.Fragment>
  );
};

DocumentLibrary.queries = {
  templates: {
    info(__, related) {
      const { '/router/query': query } = related;
      const cursor = listParams(query);
      return {
        id: '/workflow/templates',
        cursor,
      };
    },
  },
};

export default compose(withSnackbarNotification, withApi)(DocumentLibrary);
